import { createContextForClass } from 'bz-utilities/hooks/context-v2';

import CacheStore from 'bz-utilities/modules/stores/cached-map-store';

import type { ServiceTypeResponse } from '../../api.dtos';

class ServicesStore extends CacheStore<ServiceTypeResponse> {
  constructor() {
    super('services');
  }
}

export const [ServicesStoreCtx, useServicesStore] = createContextForClass(ServicesStore);

export default ServicesStore;
